<template>
  <v-layout class="column fill-height">
    <app-header></app-header>
    <div class="cover">
      <v-layout class="cover__layer pt-3 pb-5" row wrap align="center">
        <v-flex xs12 order-xs2 order-md4 layout row wrap class="pt-2 container justify-center">
          <!--<v-flex xs12 class="select">
            <v-select clearable clear-icon="clear" flat label="Settore" class="pr-2 pl-2" background-color="accent" color="primary" item-text="name" item-value="id" v-model="sectorId" :items="filters.sectors" solo></v-select>
          </v-flex>-->
          <v-flex xs12 class="select">
            <v-text-field flat label="Filtra per titolo" v-model="search" solo class="search-field flat pr-2 pl-2"></v-text-field>
          </v-flex>
          <v-flex xs12 class="select">
            <v-select clearable clear-icon="clear" flat label="Finalità" class="pr-2 pl-2" background-color="accent" color="primary" item-text="name" item-value="id" v-model="aimId" :items="filters.aims" solo></v-select>
          </v-flex>
          <v-flex xs12 class="select">
            <v-select clearable clear-icon="clear" flat label="Regione" class="pr-2 pl-2" background-color="accent" color="primary" solo item-text="name" item-value="id" v-model="regionId" :items="filters.regions"></v-select>
          </v-flex>
        </v-flex>
       <!-- <v-flex xs12 layout order-xs3 order-md3 row center class="justify-center search container pt-2">
          <v-text-field flat label="Filtra per titolo" v-model="search" solo class="search-field flat pr-2 pl-2"></v-text-field>
        </v-flex>-->
        <v-flex xs12 order-xs1 order-md2 layout row wrap class="container pt-5">
          <v-flex xs12 class="garamond text-xs-center"><h1 class="white--text">Incentivi Monitor</h1></v-flex>
          <v-flex xs12 class="garamond text-xs-center pt-2 pb-2">
            <h2 class="white--text">
              Il database dei bandi promossi dalle Camere di commercio italiane
            </h2>
          </v-flex>
          <v-flex xs12 class="pt-2 pb-4">
            <div class="divider primary"></div>
          </v-flex>
          <v-flex xs12 md8 class="text-xs-center mr-auto ml-auto mb-2">
             <h2 class="sans white--text">
               Trova il bando camerale su misura per la tua impresa
             </h2>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <v-container class="pa-0 layout row align-center">
      <div v-if="items === null" v-bind:key="3" class="layout row justify-center align-center ma-5">
        <v-progress-circular
          :size="60"
          :width="3"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <transition-group v-else name="fade" class="flex" mode="in-out">
        <v-container layout row wrap class="justify-start pt-5 pr-0 pl-0 pb-5" v-bind:key="1" v-if="items !== null && filterList.length > 0">
            <router-link target='_blank' :to="{name: 'item', params: {id: item['id']}}" class="flex justify-start xs12 md4 lg4 xl3 pa-3 layout row wrap" v-for="(item) in filterList" :key="item.id">
              <v-flex xs12 layout row wrap class="box align-start">
                <v-flex xs12 class="image" :style="{'background': 'url(' + process + 'storage/' +item['photo'] + ') #eee center', 'backgroundSize': 'cover'}">
                  <span v-if="item['meta_label'] != null" class="category sans">{{item['meta_label']}}</span>
                </v-flex>
                <v-flex xs12 class="sans cciaa pr-3 pl-3 layout row align-center">
                  <v-flex><h3 class="text accent--text">{{item['cciaa']['name']}}</h3></v-flex>
                </v-flex>
                <v-flex xs12 class="sans layout column align-start">
                  <v-flex><h3 class="title secondary--text pr-3 pl-3 pb-3">{{item['meta_title']}}</h3></v-flex>
                </v-flex>
                <v-flex xs12 class="layout row">
                  <v-flex xs6 class="accent opened sans text-xs-center">
                    <h4 class="white--text">Data apertura</h4>
                    <h5 class="white--text">{{item['meta_opened_at'] | date}}</h5>
                  </v-flex>
                  <v-flex xs6 class="primary closed sans text-xs-center">
                    <h4 class="white--text">Data chiusura</h4>
                    <h5 class="white--text">{{item['meta_closed_at'] | date}}</h5>
                  </v-flex>
                </v-flex>
              </v-flex>
            </router-link>
        </v-container>
        <v-container layout row wrap v-bind:key="2" v-if="items !== null && filterList.length === 0" class="justify-center pt-5 pb-5">
          <h2 class="garamond">Nessun bando trovato</h2>
        </v-container>
      </transition-group>
    </v-container>
    <app-footer></app-footer>
  </v-layout>
</template>

<script>
  import moment from 'moment'
  import Header from './header'
  import Footer from './footer'
  import Services from '../services'
  export default {
    props: ['data'],
    filters: {
      date: function (date) {
        if (!date) {
          return 'N/A'
        }
        return moment(date).locale('it').format('DD MMM YYYY');
      }
    },
    methods: {
      list() {
        this.items = null
        Services.incentives(this.sectorId, this.regionId, this.aimId).then(res => {
          this.items = res.filter(obj => {
            return moment(obj['meta_closed_at']).isAfter(moment())
          })
        })
      }
    },
    computed: {
      filterList() {
        return this.items.filter(obj => {
          if(this.search !== null && this.search !== undefined) {
            obj = obj['meta_title'].toLowerCase().indexOf(this.search.toLowerCase()) !== -1 || obj['cciaa']['name'].toLowerCase().indexOf(this.search.toLowerCase()) !== -1
          }
          return obj
        })
      }
    },
    watch: {
      aimId: function(){
        this.list()
      },
      regionId: function(){
        this.list()
      },
      sectorId: function(){
        this.list()
      },
    },
    components: {
      'app-header': Header,
      'app-footer': Footer,
    },
    data () {
       return {
        aimId: "",
        regionId: "",
        sectorId: "",
        callStatus: true,
        items: null,
        search: null,
        process: null,
        filters: {
          aims: [],
          sectors: [],
          regions: [
            {
              name: "Abruzzo",
              id: 1
            }, {
              name: "Basilicata",
              id: 2
            }, {
              name: "Calabria",
              id: 3
            }, {
              name: "Campania",
              id: 4
            }, {
              name: "Emilia Romagna",
              id: 5
            }, {
              name: "Friuli Venezia Giulia",
              id: 6
            }, {
              name: "Lazio",
              id: 7
            }, {
              name: "Liguria",
              id: 8
            }, {
              name: "Lombardia",
              id: 9
            }, {
              name: "Marche",
              id: 10
            }, {
              name: "Molise",
              id: 11
            }, {
              name: "Piemonte",
              id: 12
            }, {
              name: "Puglia",
              id: 13
            }, {
              name: "Sardegna",
              id: 14
            }, {
              name: "Sicilia",
              id: 15
            }, {
              name: "Toscana",
              id: 16
            }, {
              name: "Trentino Alto Adige",
              id: 17
            }, {
              name: "Umbria",
              id: 18
            }, {
              name: "Valle d'Aosta",
              id: 19
            }, {
              name: "Veneto",
              id: 20
            }
          ]
        },
        status: [
          {name: "In corso", value: true},
          {name: "Scaduto", value: false},
        ],
      }
    },
    created: function() {
      this.process = process.env.VUE_APP_PUBLIC;
      Services.areas().then(res => {
        this.filters.sectors = res
      })
      Services.finalities().then(res => {
        this.filters.aims = res
      })
      Services.incentives().then(res => {
        this.items = res
      })
    }
  }
</script>

<style scoped lang="scss">
  a{
    text-decoration: none;
    color: initial;
  }
  .search{
    margin: auto;
    max-width: 535px;
  }
  .hover{
    cursor: pointer;
    -webkit-transition: background-color 200ms linear;
    -moz-transition: background-color 200ms linear;
    -o-transition: background-color 200ms linear;
    -ms-transition: background-color 200ms linear;
    transition: background-color 200ms linear;
    &:hover {
      background: rgb(237,237,237);
    }
  }
  .text{
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 1.2;
    height: 21px;
    clear: both;
    max-width: 100%;
    display: inline-block;
    white-space: nowrap;
    font-size: 18px !important;
  }
  .index{
    font-size: 16px;
    font-weight: 300;
  }
  @media (min-width:801px) {
    .select {
      max-width: 220px;
    }
  }
  .cover{
    background: url("../assets/cover.png") bottom no-repeat;
    background-size: cover;
  }
  .cover__layer{
    background: rgba(0,0,0,0.35);
  }
  .box{
    border-radius: 10px;
    box-shadow: 0px 0px 15px #00000026;
    border: 2px solid transparent;

    -webkit-transition: all 1s ease-out;
    -moz-transition: all 1s ease-out;
    -o-transition: all 1s ease-out;
    transition: all 1s ease-out;
    &:hover{
      border: 2px solid var(--v-accent-base);
    }
    .image{
      height: 175px;
      background: #e5e5e5;
      border-top-left-radius: 8px;
      text-align: right;
      border-top-right-radius: 8px;
      padding: 20px;
      .category {
        color:  var(--v-accent-base);
        font-size: 16px;
        font-weight: bold;
        border-radius: 4px;
        background: #fff;
        padding: 4px 18px;
        text-transform: uppercase;
        border: 2px solid var(--v-accent-base);
      }
    }
    .title{
      height: 115px;
      overflow: hidden;
      line-height: 1.7rem !important;
      font-weight: 600;
      margin-bottom: 16px;
    }
    .cciaa {
      height: 50px;
    }
    .opened{
      height: 60px;
      padding: 6px 0 6px 0;
      border-bottom-left-radius: 8px;
    }
    .closed{
      height: 60px;
      padding: 6px;
      border-bottom-right-radius: 8px;
    }
  }
</style>
